import {Shower} from "../../parts/shower";
import {createParentPositions} from "../../constants";
import AccessoryCommon from "./accessoryCommon";

export default class LargeCornerSeat extends AccessoryCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'large_corner_seat';
    this.partName = 'Large Corner Seat';
    this.translateId = "visualizer.bathroom.accessories.large_corner_seat";
    this.visible = true;
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  setLayers(layout) {

    const showerParent = this.getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerTubComboIsActive()) { //  shower tub combo - remove
      super.hideLayers();
      return;
    }

    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      // this.checkIfFeaturePartIsMatching();
      return super.setLayers(layout);
    }

    this.setDefault();
    return super.setLayers(layout);
  }

  // setZIndex(zIndexes) {
  //   if (zIndexes) {
  //     Object.keys(this.layerPositions).forEach((key, keyIndex) => {
  //       if (this.layerPositions[key]) {
  //         this.layerPositions[key].layer.zIndex = zIndexes.Accessories.LargeCornerSeat + keyIndex*10;
  //       }
  //     })
  //   }
  // }

}

